import { render, staticRenderFns } from "./VaccineReminderEditPopup.vue?vue&type=template&id=0cf7f6b2&scoped=true&"
import script from "./VaccineReminderEditPopup.vue?vue&type=script&lang=js&"
export * from "./VaccineReminderEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./VaccineReminderEditPopup.vue?vue&type=style&index=0&id=0cf7f6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7f6b2",
  null
  
)

export default component.exports